import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import Grid from '@material-ui/core/Grid';

import { DatePicker, Select, Button } from 'components';
import { saveAs } from 'file-saver';
import { Formik, Field, Form } from 'formik';
import { downloadcsv } from 'helpers/downloadcsv';
import { AuthContext } from 'hooks/useAuth';
import { PageTitle } from 'pages/Layout/PageTitle';
import { launchPrivider } from 'services';
import { useContextSelector } from 'use-context-selector';

export const CompactReport = () => {
  const [clientOption, setClientOption] = useState([]);
  const [conditiontOption, setconditionOption] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [disableLaudo, setDisableLaudo] = useState(false);
  const user = useContextSelector(AuthContext, (context) => context.user);

  const onSubmitHandler = async (values, resetForm) => {
    const startDate = new Date(values.start_date);
    const endDate = new Date(values.end_date);
    const diffInDays = Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24));

    if (diffInDays < 0) {
      toast.error('A data de saída deve ser posterior à data de entrada.');
      return;
    }
    if (diffInDays > 31) {
      toast.error('O intervalo entre as datas deve ser de no máximo 31 dias.');
      return;
    }

    setIsLoading(true);
    if (values?.client.length === 0) {
      setIsLoading(false);
      toast.error('Não foi selecionado um cliente');
      return;
    }
    if (values?.client.length > 4) {
      setIsLoading(false);
      // Exibe uma mensagem de erro (pode ser substituído por algo visual no seu caso)
      toast.error('Você só pode selecionar no máximo 4 clientes.');
      return;
    }

    toast.info('Aguarde o sistema gerar os laudos');
    try {
      if (values.client.includes('TODOS')) {
        values.client = clientOption.map((item) => item.value);
      }

      const temp = { ...values, user: user };
      const { data } = await launchPrivider.generateCompressedReport(temp);
      const file = new Blob([data], { type: 'application/zip' });
      saveAs(file, 'compactarLaudo.zip');
      toast.success('Zip gerado com sucesso.');
    } catch (error) {
      if (error.response && error.response.data instanceof Blob) {
        const errorBlob = error.response.data;
        const reader = new FileReader();
        reader.onload = () => {
          const errorMessage = JSON.parse(reader.result).message || 'Erro desconhecido';
          toast.error('Erro ao gerar o relatório: ' + errorMessage);
        };
        reader.onerror = () => {
          toast.error('Erro ao gerar o relatório: Erro ao ler a mensagem de erro');
        };
        reader.readAsText(errorBlob);
        setIsLoading(false);
      } else {
        // Captura a mensagem de erro correta se não for um Blob
        const errorMessage = error.response?.data?.message || error.message || 'Erro desconhecido';
        toast.error('Erro ao gerar o relatório: ' + errorMessage);
      }
    } finally {
      setDisableLaudo(false);
      setIsLoading(false);
      resetForm();
    }
  };

  const handleExport = async (values, resetForm) => {
    if (values.client.length === 0) {
      toast.error('Não foi possivel extrair relatório, selecione pelo menos um cliente.');
      return;
    }
    if (values.client.includes(0)) {
      values.client = clientOption.map((item) => item.value);
    }
    console.log('jnfiuswdbfuwbdicbw', values.client);

    setIsLoading(true);
    toast.info('Aguarde ...');
    try {
      const { data } = await launchPrivider.reportsServiceOrdem(values);
      if (data.length === 0) {
        return toast.error('Não há dados para extrair relatório');
      }
      downloadcsv('ingenico_compactar_laudos', data);
      toast.info('Sucesso.');
    } catch (error) {
      console.error(error);
      toast.error('Não foi possivel extrair relatório.');
    } finally {
      setDisableLaudo(false);
      setIsLoading(false);
      resetForm();
    }
  };
  const getListClient = useCallback(async () => {
    const jsonObject = JSON.parse(localStorage.getItem('@Gaia:user'));
    const { data } = await launchPrivider.getListClient(jsonObject.role.alias.toUpperCase());
    const allClients = [{ label: 'TODOS', value: 0 }, ...data];
    setClientOption(allClients);
  }, []);

  const getListCondition = useCallback(async () => {
    const { data } = await launchPrivider.getListCondition();
    const isGetUser = user?.role?.alias.toUpperCase() === 'GET';
    const filteredData = isGetUser ? data.filter((item) => item.value === 'IRREPARÁVEL') : data;
    setconditionOption(filteredData);
  }, [user]);

  useEffect(() => {
    getListClient();
    getListCondition();
  }, [getListClient, getListCondition]);

  return (
    <>
      <PageTitle>Compactar Laudo</PageTitle>
      <Formik
        initialValues={{
          start_date: new Date(),
          end_date: new Date(),
          client: [],
          condition: 'TODOS',
        }}
        onSubmit={onSubmitHandler}
      >
        {({ values, resetForm, setFieldValue }) => (
          <>
            <Form>
              <Grid container spacing={2}>
                <Grid item xs={12} lg={3}>
                  <Field
                    size='small'
                    name='start_date'
                    variant='inline'
                    fullWidth
                    inputVariant='outlined'
                    label='Data de entrada'
                    component={DatePicker}
                    loading={isLoading}
                    disabled={false}
                  />
                </Grid>
                <Grid item xs={12} lg={3}>
                  <Field
                    size='small'
                    name='end_date'
                    variant='inline'
                    fullWidth
                    inputVariant='outlined'
                    label='Data de saida'
                    component={DatePicker}
                    loading={isLoading}
                    disabled={false}
                  />
                </Grid>
                <Grid item xs={12} lg={3}>
                  <Field
                    multiple
                    size='small'
                    name='client'
                    label='Selecione o cliente'
                    variant='outlined'
                    options={clientOption.map((option) => ({
                      ...option,
                      // Desativa todas as outras opções se 'TODOS' estiver selecionado
                      disabled: values.client.includes(0) && option.value !== 0,
                    }))}
                    component={Select}
                    loading={isLoading}
                    onChange={(e) => {
                      const selectedClients = e;

                      // Se "TODOS" for selecionado
                      if (selectedClients.includes(0)) {
                        setDisableLaudo(true); // Desativa a seleção
                        // Define o valor como apenas "TODOS"
                        setFieldValue('client', [0]);
                      } else {
                        // Caso contrário, permite seleção normal até 4 clientes
                        setDisableLaudo(false);

                        if (selectedClients.length > 4) {
                          // Exibe uma mensagem de erro (pode ser substituído por algo visual no seu caso)
                          alert('Você só pode selecionar no máximo 4 clientes.');
                          // Não permite adicionar mais opções, retorna os 4 primeiros selecionados
                          setFieldValue('client', selectedClients.slice(0, 4));
                        } else {
                          // Atualiza os valores selecionados
                          setFieldValue('client', selectedClients);
                        }
                      }
                    }}
                  />
                </Grid>

                <Grid item xs={12} lg={3}>
                  <Field
                    size='small'
                    name='condition'
                    label='Selecione a condição'
                    variant='outlined'
                    options={conditiontOption}
                    component={Select}
                    loading={isLoading}
                  />
                </Grid>
                <Grid item xs={12} lg={3}>
                  <Button
                    variant='contained'
                    color='primary'
                    fullWidth
                    disabled={isLoading || disableLaudo}
                    loading={isLoading}
                    type='submit'
                  >
                    gerar arquivo.zip
                  </Button>
                </Grid>
                <Grid item xs={12} lg={3}>
                  <Button
                    variant='contained'
                    color='primary'
                    fullWidth
                    disabled={isLoading}
                    loading={isLoading}
                    onClick={() => handleExport(values, resetForm)}
                  >
                    exportar planilha
                  </Button>
                </Grid>
              </Grid>
            </Form>
          </>
        )}
      </Formik>
    </>
  );
};
